import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["direction", "children", "className", "top", "right", "bottom", "left", "spread"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../components/Base';
var styles = {
  "root": "Divider-root_19iN1",
  "spreadEqual": "Divider-spreadEqual_2oSTJ"
};
var separatorStyles = {
  "top": "Separator-top_1Xr7Z",
  "right": "Separator-right_1XxB-",
  "bottom": "Separator-bottom_3ONff",
  "left": "Separator-left_S7AIK",
  "bottomToRight": "Separator-bottomToRight_3gEo7"
};
/**
 * Helper component to insert proper Separators between child components.
 * It's a thin line (1px margin), that should let the underneath background pass trough.
 */
function Divider(_ref) {
  var _childClasses;
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction,
    children = _ref.children,
    className = _ref.className,
    top = _ref.top,
    right = _ref.right,
    bottom = _ref.bottom,
    left = _ref.left,
    spread = _ref.spread,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var childClasses = (_childClasses = {}, _defineProperty(_childClasses, separatorStyles.top, top), _defineProperty(_childClasses, separatorStyles.right, right || direction === 'row'), _defineProperty(_childClasses, separatorStyles.bottom, bottom || direction === 'column'), _defineProperty(_childClasses, separatorStyles.left, left), _defineProperty(_childClasses, separatorStyles.bottomToRight, direction === 'columnToRow'), _defineProperty(_childClasses, styles.spreadEqual, spread === 'equal'), _childClasses);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      flex: true,
      flexGrow1: true,
      flexRow: direction === 'row',
      flexCol: direction === 'column',
      flexColToRow: direction === 'columnToRow',
      className: clsx(styles.root, className)
    }, extraProps), React.Children.toArray(children).map(function (child) {
      return /*#__PURE__*/React.cloneElement(child, {
        className: clsx(childClasses, child.props.className)
      });
    }))
  );
}
export default Divider;